import React, { memo, useRef } from "react";
import Button from "@mui/material/Button";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import Popover from "@mui/material/Popover";
import { IoEllipse } from "react-icons/io5";
import { PaymentMethodType } from "@store/Payment";
import { CircularProgress } from "@mui/material";
// IoEllipse

const masterCardImage = require("@img/icons/stripe/mastercard-card.png");
const visaImage = require("@img/icons/stripe/visa-card.png");
const amexImage = require("@img/icons/stripe/amex-card.png");
const unionImage = require("@img/icons/stripe/union-card.png");
const jcbImage = require("@img/icons/stripe/jcb-card.png");
const discoverImage = require("@img/icons/stripe/discover-card.png");
const dinersImage = require("@img/icons/stripe/diners-card.png");

interface ICardImageParser {
  [string: string]: any;
}

interface CardStripeProps {
  item: PaymentMethodType;
  isSelected?: boolean;
  onPressRemove?: () => void;
  onPressSetDefault?: () => void;
  isLoadingRemove?: boolean;
  isLoadingSetDefault?: boolean;
}

const cardImageParser: ICardImageParser = {
  visa: visaImage,
  amex: amexImage,
  mastercard: masterCardImage,
  unionpay: unionImage,
  jcb: jcbImage,
  diners: dinersImage,
  discover: discoverImage,
};

const CardStripe = ({
  item,
  isSelected,
  onPressRemove,
  onPressSetDefault,
  isLoadingRemove,
  isLoadingSetDefault,
}: CardStripeProps) => {
  const [anchorEl, setAnchorEl] = React.useState<any | null>(null);
  const buttonRef = useRef(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setAnchorEl(buttonRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const idCancel = open ? "simple-popover" : undefined;

  return (
    <div
      className={`borderWidth-2 p-8 rounded-lg relative ${
        isSelected
          ? "!border-bahama_blue_hover border-4"
          : "!border-gray-400 borderWidth-2"
      }`}
    >
      <div>
        <div className="flex flex-row items-center">
          <img src={cardImageParser[item.cardType]} className={"h-16 w-24"} />
          {item.isDefault && (
            <div className="borderWidth p-1 rounded-xl !border-green-500">
              <h3 className="text-xl flex flex-row items-center">
                <IoEllipse className="mr-2 text-green-500" /> Default
              </h3>
            </div>
          )}
        </div>
        <h1 className="mt-3">{`Ending in ${item.lastDigit}`}</h1>
      </div>
      {onPressSetDefault || onPressRemove ? (
        <div className="absolute cursor-pointer top-1 right-1">
          <Button onClick={handleClick} size="small" ref={buttonRef}>
            <MoreHorizRoundedIcon style={{ fontSize: 30 }} />
          </Button>
          <Popover
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <div className="">
              {onPressSetDefault ? (
                <div className="flex flex-row border-solid border-b-2 items-center">
                  <h1
                    className="px-4 py-4 font-semibold cursor-pointer"
                    onClick={onPressSetDefault}
                  >
                    Set Default Credit Card
                  </h1>
                  {isLoadingSetDefault && (
                    <CircularProgress
                      className="mr-6"
                      size={20}
                    ></CircularProgress>
                  )}
                </div>
              ) : null}
              {onPressRemove ? (
                <div className="flex flex-row items-center">
                  <h1
                    className="px-4 py-4 font-semibold cursor-pointer border-solid"
                    onClick={onPressRemove}
                  >
                    Remove Credit Card
                  </h1>
                  {isLoadingRemove && (
                    <CircularProgress
                      className="mr-6"
                      size={20}
                    ></CircularProgress>
                  )}
                </div>
              ) : null}
            </div>
          </Popover>
        </div>
      ) : null}
    </div>
  );
};

export default memo(CardStripe);
